import { Select } from "antd";
import { IoIosArrowDown } from "react-icons/io";

const { Option } = Select;
const SelectComponent = ({ props }) => {
  return (
    <Select
      value={props.value}
      style={props.style}
      onChange={props.onChange}
      suffixIcon={<IoIosArrowDown size={18} />}
    >
      {props.Array.map((action, i) => (
        <Option key={i} value={action?.value ? action?.value : action}>
          {action?.label ? action.label : action}
        </Option>
      ))}
    </Select>
  );
};
export default SelectComponent;
